import axios from 'axios';

export class CloseService {
    isClose() {
        return axios.get('/appapv/isClose.action', {
            params: {}
        }).then(res => res.data);
    }

    getValidationClose() {
        return axios.get('/appapv/getValidationClose.action', {
            params: {}
        }).then(res => res.data);
    }

    close() {
        return axios.post('/appapv/close.action', {}, {
            params: {}
        }).then(res => res.data);
    }

    returnClose() {
        return axios.post('/appapv/returnClose.action', {}, {
            params: {}
        }).then(res => res.data);
    }
}